import { render, staticRenderFns } from "./SizeSelected.vue?vue&type=template&id=3149eae8&"
import script from "./SizeSelected.vue?vue&type=script&lang=js&"
export * from "./SizeSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports